//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Issue.js";
import "../no/Builder.js";
let d=[[[0,"AssignedUser",1,0],[0,"Comment",1,0],[0,"DueDate",1,0],[0,"Priority",1,0],[0,"Status",1,0],[0,"Title",1,0]],[[["nProperties"],"GetEditableUserProperties",{R_:{properties:"Issue.IssueProperty[]"}},0,0],[["propertyName","propertyValue"],"SetPropertyValue",{},2,0],[["propertyName"],"GetPropertyValue",{R_:{propertyValue:''}},1,0],[["nAttachments"],"GetAllAttachments",{R_:{attachments:"Issue.IssueAttachment[]"}},0,0],[["attachmentName"],"GetAttachment",{R_:{attachment:"Issue.IssueAttachment"}},1,0],[["attachment"],"AddAttachment",{},1,0],[["attachment"],"RemoveAttachment",{},1,0],[["attachment"],"SetPreviewImage",{},1,0]],[]];
SPLM.Issue.IssueContentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Issue.IssueContentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;